interface AppsIconProps {
  isActive?: boolean;
  className?: string;
}

const AppsIcon = ({ isActive = false, className = '' }: AppsIconProps) => {
  return (
    <svg
      className={`mr-2 h-5 w-5 ${className}`}
      fill={isActive ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
    </svg>
  );
};

export default AppsIcon;
